import { createRouter, createWebHistory } from "vue-router"
import Login from "../views/Login.vue"
import { useAuthStore } from "@/stores"
import { getDeviceType } from "@/helpers/utility"
import { eventBus } from "@/helpers/eventBus"

const deviceType = getDeviceType()

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    { path: "/", redirect: "/dashboard" },
    {
      path: "/activate-license",
      name: "activate",
      component: () => import("../pages/ActivateLicense.vue"),
    },
    {
      path: "/:pathMatch(.*)*",
      redirect: "/",
    },
    {
      path: "/",
      component: () => import("../layouts/DynamicLayout.vue"),
      children: [
        {
          path: "fetchData",
          name: "fetchData",
          component: () => import("../components/FetchData.vue"),
        },
        {
          path: "dashboard",
          name: "dashboard",
          component: () => import("../pages/Dashboard.vue"),
        },
        {
          path: "ticket/:actionPage?",
          name: "ticket-list",
          component: () => {
            if (deviceType === "mobile") {
              return import("../pages/ticket/mobile/list.vue")
            } else {
              return import("../pages/ticket/desktop/list.vue")
            }
          },
        },
        {
          path: "ticket-action/:ticketAction/:id/:actionPage",
          name: "ticket-action",
          component: () => {
            if (deviceType === "mobile") {
              return import("../pages/ticket/mobile/ticket.vue")
            } else {
              return import("../pages/ticket/desktop/ticket.vue")
            }
          },
        },
        {
          path: "filter-manage/:actionPage",
          name: "filter-manage",
          component: () => import("../pages/filter/index.vue"),
        },
        {
          path: "chartfilter-manage/:actionPage",
          name: "chartfilter-manage",
          component: () => import("../pages/chartfilter/index.vue"),
        },
        {
          path: "user",
          name: "user-list",
          component: () => import("../pages/user/list.vue"),
        },
        {
          path: "user/:action/:id",
          name: "user",
          component: () => import("../pages/user/createEdit.vue"),
        },
        {
          path: "user-edit/:id",
          name: "user-edit",
        },
        {
          path: "field",
          name: "field-list",
          component: () => import("../pages/field/list.vue"),
        },
        {
          path: "field/:mode(create|edit)/:id?",
          name: "field-manage",
          component: () => import("../pages/field/createEdit.vue"),
        },
        {
          path: "layout",
          name: "layout-list",
          component: () => import("../pages/layout/list.vue"),
        },
        {
          path: "layout/:mode(create|edit)/:id?",
          name: "layout-manage",
          component: () => import("../pages/layout/createEdit.vue"),
        },
        {
          path: "screen",
          name: "screen-list",
          component: () => import("../pages/screen/list.vue"),
        },
        {
          path: "screen/:mode(create|edit)/:id?",
          name: "screen-manage",
          component: () => import("../pages/screen/createEdit.vue"),
        },
        {
          path: "workflow",
          name: "workflow-list",
          component: () => import("../pages/workflow/list.vue"),
        },
        {
          path: "workflow/:mode(create|edit)/:id?",
          name: "workflow-manage",
          component: () => import("../pages/workflow/createEdit.vue"),
        },
        {
          path: "workflow-edit/:id",
          name: "workflow-edit",
        },
        {
          path: "role",
          name: "role-list",
          component: () => import("../pages/role/list.vue"),
        },
        {
          path: "role/:action/:id",
          name: "role",
          component: () => import("../pages/role/createEdit.vue"),
        },
        {
          path: "role/:action/:id",
          name: "role-edit",
        },
        {
          path: "status",
          name: "status-list",
          component: () => import("../pages/status/list.vue"),
        },
        {
          path: "status/:mode(create|edit)/:id?",
          name: "status-manage",
          component: () => import("../pages/status/createEdit.vue"),
        },
        {
          path: "project",
          name: "project-list",
          component: () => import("../pages/project/list.vue"),
        },
        {
          path: "project/:mode(create|edit)/:id?",
          name: "project-manage",
          component: () => import("../pages/project/createEdit.vue"),
        },
        {
          path: "page",
          name: "page-list",
          component: () => import("../pages/page/list.vue"),
        },
        {
          path: "page/:mode(create|edit)/:id?",
          name: "page-manage",
          component: () => import("../pages/page/createEdit.vue"),
        },
        {
          path: "refnumber",
          name: "refnumber-list",
          component: () => import("../pages/refnumber/list.vue"),
        },
        {
          path: "refnumber-create",
          name: "refnumber-create",
        },
        {
          path: "refnumber/:mode(create|edit)/:id?",
          name: "refnumber-manage",
          component: () => import("../pages/refnumber/createEdit.vue"),
        },
        {
          path: "usergroup",
          name: "usergroup-list",
          component: () => import("../pages/usergroup/list.vue"),
        },
        {
          path: "usergroup/:action/:id",
          name: "usergroup",
          component: () => import("../pages/usergroup/createEdit.vue"),
        },
        {
          path: "usergroup-edit/:id",
          name: "usergroup-edit",
        },
        {
          path: "notifications",
          name: "notifications",
          component: () => import("../pages/notification/index.vue"),
        },
        {
          path: "reports",
          name: "reports",
          component: () => import("../pages/report/index.vue"),
        },
        {
          path: "profile",
          name: "Profile",
          component: () => import("../layouts/Profile.vue"),
        },
        {
          path: "changepassword",
          name: "change-password",
          component: () => import("../layouts/ChangePassword.vue"),
        },
        {
          path: "view-manage/:actionPage",
          name: "view-manage",
          component: () => import("../pages/view/index.vue"),
        },
        {
          path: "customframesetting",
          name: "customframesetting-list",
          component: () => import("../pages/customframesetting/list.vue"),
        },
        {
          path: "customframesetting/:mode(create|edit)/:id?",
          name: "customframesetting-manage",
          component: () => import("../pages/customframesetting/createEdit.vue"),
        },
        {
          path: "customframesetting/view/:id?",
          name: "customframesetting-view",
          component: () => import("../pages/customframesetting/view.vue"),
        },
        {
          path: "system",
          name: "system",
          component: () => import("../pages/system/index.vue"),
        },
        {
          path: "customframe",
          name: "customframe",
          component: () => import("../pages/customframe/index.vue"),
        },
        {
          path: "priority",
          name: "priority-list",
          component: () => import("../pages/priority/list.vue"),
        },
        {
          path: "priority/:mode(create|edit)/:id?",
          name: "priority-manage",
          component: () => import("../pages/priority/createEdit.vue"),
        },
        {
          path: "sla",
          name: "sla-list",
          component: () => import("../pages/sla/list.vue"),
        },
        {
          path: "sla/:mode(create|edit)/:id?",
          name: "sla-manage",
          component: () => import("../pages/sla/createEdit.vue"),
        },
        {
          path: "sladata",
          name: "sladata",
          component: () => import("../pages/sladata/index.vue"),
        },
        {
          path: "activitylog",
          name: "activitylog",
          component: () => import("../pages/activitylog/index.vue"),
        },
      ],
    },
    {
      path: "/",
      component: () => import("../layouts/blank.vue"),
      children: [
        {
          path: "resetPassword/:id",
          name: "reset-password",
          component: () => import("../layouts/ResetPassword.vue"),
        },
      ],
    },
  ],
})

router.beforeEach(async (to) => {
  const publicPages = [
    "/login",
    "/resetPassword",
    "/account",
    "/activate-license",
  ]
  const routeBasePath = to.path.split("/")[1]
  const isPublic = publicPages.includes("/" + routeBasePath) || to.meta?.public

  const authStore = useAuthStore()

  if (!isPublic && !authStore.user) {
    authStore.returnUrl = to.fullPath

    return "/login"
  }

  if (to.path.startsWith("/ticket") && !to.params.actionPage) {
    return "/"
  }

  if (!isPublic) {
    await eventBus.value.emit("pageChange")
  }
})

export default router
